"use strict";

exports.__esModule = true;
exports.LayoutSelector = LayoutSelector;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Selector = require("../../Core/Selector");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function getKey(input) {
  return input.id;
}
function renderItemText(input) {
  return input.name;
}
function renderItemDescription(input) {
  return /*#__PURE__*/_react["default"].createElement(_core.Text, {
    ellipsize: true
  }, input.element.props.description);
}
function itemPredicate(query, layout) {
  var description = layout.element.props.description;
  return new RegExp(query, "gi").test(layout.id) || new RegExp(query, "gi").test(layout.name) || new RegExp(query, "gi").test(typeof description === "string" ? description : "");
}

/**
 * Allows a user to select layout(s) from a list.
 */
function LayoutSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
      placeholder: props.multiple ? translate("LayoutSelector.placeholder.multiple", "Select Layouts") : translate("LayoutSelector.placeholder.single", "Select Layout"),
      getKey: getKey,
      renderItemText: renderItemText,
      renderItemDescription: renderItemDescription,
      virtualScrollProps: {
        itemSize: 60,
        itemCount: 6,
        overscanCount: 5
      },
      itemPredicate: itemPredicate
    }, props));
  });
}